<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema } from '@bagelink/vue'
const schema = defineSchema({})
export const SeriesTableOfContents = defineBlock({
	thumbnail: '/block-thumbs/SeriesTableOfContents.svg',
	category: 'Listings',
	order: 350,
	name: 'SeriesTableOfContents',
	label: 'Series TOC',
	icon: 'toc',
	schema,
})
</script>
<script setup lang="ts">


import { computed } from 'vue'
import { useBoundPageModel } from '@/composables/useBoundPageItem'
import { sanitizeArticleTitleHtml } from '@/utils/articleHtml'



interface TableSection {
	title: string
	items: Array<{
		number: number
		title: string
		link: string
	}>
}

const previewRecord = { _id: 'preview-series' }
const previewArticles = [
	{
		_id: 'preview-article',
		seriesId: 'preview-series',
		seriesOrder: 1,
		title: 'Sample Article',
		slug: 'sample-article',
	},
]

function normalizeSections(record: Record<string, any>): TableSection[] {
	const source = record._id === previewRecord._id ? previewArticles : (record._ssgArticles ?? [])
	const related = source
		.filter((article: any) => article.seriesId === record._id)
		.sort((a: any, b: any) => (a.seriesOrder ?? 999) - (b.seriesOrder ?? 999))
	if (!related.length) return []
	return [
		{
			title: '',
			items: related.map((article: any, index: number) => ({
				number: article.seriesOrder || index + 1,
				title: article.title || '',
				link: article.slug ? `/article/${article.slug}` : '',
			})),
		},
	]
}

const model = useBoundPageModel(normalizeSections, previewRecord)
const sections = computed<TableSection[]>(() => model.value ?? [])
</script>

<template>
	<div v-if="sections.some(section => section.items.length > 0)" class="w720px mx-auto m_px-1 py-3">
		<h3 class="txt30 regular m-0 line-height-12 balance pb-05">Table of Contents</h3>

		<div v-for="section in sections" :key="section.title" class="py-1">
			<h4 v-if="section.title" class="txt18 m-0 line-height-14 light">
				{{ section.title }}
			</h4>

			<div class="display-flex column gap-075">
				<router-link
					v-for="item in section.items"
					:key="item.number"
					:to="item.link"
					class="flex gap-05 align-items-start p-1 bg-gray hover decoration-none txt17 bold"
				>
					<span class="flex-shrink-0">{{ item.number }}.</span>
					<span v-html="sanitizeArticleTitleHtml(item.title)" />
				</router-link>
			</div>
		</div>
	</div>
</template>
